import { NotesTab as SharedNotesTab } from '@pmp/components';
import { TabProps } from '../interfaces';

export const NotesTab: React.FC<TabProps> = ({ form, entityType, entityId }) => (
  <SharedNotesTab form={form} entityType={entityType} entityIdField="firmId" entityId={entityId} />
);
